export enum DiscountType {
  Percent = 1,
  Dollars = 2,
}
